import NewsletterLoader from './newsletterloader.js';
function init () {
    NewsletterLoader.init();
};

init();